// Libraries
import {
  Directive,
  Input,
  Output,
  EventEmitter,
  Renderer2,
  ElementRef,
  HostListener
} from '@angular/core';

/**
 * `ToggleClassDirective`
 */
@Directive({
  selector: '[wpToggleClass]'
})
export class ToggleClassDirective {
  // Public properties
  /**
   * Target class to add
   */
  @Input() targetClass: string = '';
  /**
   * Target to search element
   */
  @Input() target: ElementRef;
  /**
   * Toggle event
   */
  @Output() toggleClass = new EventEmitter();
  /**
   * Bind click event to element
   */
  @HostListener('click') onClick() {
    // Handles click event
    this.onClickTarget();
  }

  // Private properties
  /**
   * Check if fullscreen item is toggled
   */
  private hasTargetClass = false;

  /**
   * Creates an instance of ToggleClassDirective.
   * @author Lautaro Klein <lautaro.klein@woopasoft.com>
   * @memberof ToggleClassDirective
   */
  constructor(
    private renderer: Renderer2
  ) {}

  // Private methods
  /**
   * Handle fullscreen item toggle
   *
   * @author Lautaro Klein <lautaro.klein@woopasoft.com>
   * @memberof ToggleClassDirective
   */
  private onClickTarget() {
    this.hasTargetClass = !this.hasTargetClass;
    // Check hasTargetClass
    if (this.hasTargetClass) {
      this.renderer.addClass(this.target, this.targetClass)
    } else {
      this.renderer.removeClass(this.target, this.targetClass);
    }
    // Emit event
    this.toggleClass.emit(this.hasTargetClass);
  }
}
